import clsx from "clsx"
import React from "react"

import ValueProps from "@/ui/patterns/ValueProps"

import Button from "../Button"
import PageGrid from "../PageGrid"

export interface ValuePropsTypes {
  wrapperClass?: string
  valueProps: {
    title: string
    description?: React.ReactNode
    link?: string
    linkClass?: string
    linkText?: string
    wrapperClass?: string
    image?: any | React.ReactNode
  }[]
  heading?: React.ReactNode
  description?: string
  buttonLink?: string
  buttonCTA?: string
  mainButton?: boolean
  align?: string
  numOfColumns?: 3 | 4
}

const UseCaseValuePropsSection: React.FC<ValuePropsTypes> = (props) => {
  const {
    heading,
    buttonCTA,
    mainButton,
    buttonLink,
    valueProps,
    description,
    wrapperClass,
    align,
    numOfColumns,
  } = props

  return (
    <section
      className={clsx("text-gray-90 py-16 md:py-22 xl:py-28", wrapperClass)}
    >
      <PageGrid className={clsx("mb-12")}>
        <div
          className={clsx(
            "p-4 inline-flex flex-col gap-6",
            align === "center" ? "text-center col-span-full" : "col-span-7",
          )}
        >
          <h3 className={clsx("headline5")}>{heading}</h3>
          {description && <p className="body2 text-gray-70">{description}</p>}
        </div>
      </PageGrid>
      <PageGrid>
        {valueProps?.map((valueProp) => (
          <div
            className={clsx(
              "col-span-2",
              numOfColumns === 4 ? "lg:col-span-3" : "lg:col-span-4",
            )}
            key={valueProp.title}
          >
            <ValueProps
              title={valueProp.title}
              description={valueProp.description}
              link={valueProp.link}
              linkClass={valueProp.linkClass}
              linkText={valueProp.linkText}
              wrapperClass={valueProp.wrapperClass}
              image={valueProp.image}
            />
          </div>
        ))}
      </PageGrid>
      {mainButton ? (
        <PageGrid>
          <div
            className={clsx(
              "col-span-full",
              align === "center" ? "text-center" : "text-left",
            )}
          >
            <Button to={buttonLink || "/contact/sales/"} size="lg">
              {buttonCTA || "Talk to our Team"}
            </Button>
          </div>
        </PageGrid>
      ) : (
        ""
      )}
    </section>
  )
}

export default UseCaseValuePropsSection
